
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_32007_149846)"}},[_c('path',{attrs:{"d":"M16.597 2.197c.253.187.403.487.403.803v10.5c0 1.381-1.344 2.5-3 2.5s-3-1.119-3-2.5c0-1.382 1.344-2.5 3-2.5.35 0 .688.05 1 .143v-4.55l-8 2.4V15.5C7 16.88 5.656 18 4 18s-3-1.119-3-2.5C1 14.118 2.344 13 4 13c.35 0 .688.05 1 .143V6c0-.44.29-.832.713-.96l10-3a.995.995 0 01.884.157z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_32007_149846"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    